import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import orderBy from 'lodash/orderBy';

import { useDeepEqualSelector } from 'Shared/utils/hooks';
import { readNotifications } from 'Shared/api';

import FeedItem from './FeedItem/FeedItem';
import EmptyState from './EmptyState/EmptyState';

type Props = {
  onCreateActionItemClick: Function;
};

function YourFeedContent({ onCreateActionItemClick }: Props) {
  const dispatch = useDispatch();
  const webNotificationsIds = useDeepEqualSelector(state =>
    orderBy(state.web_notifications, ({ sentAt }) => sentAt, 'desc').map(({ id }) => id)
  );
  const showEmptyState = webNotificationsIds.length <= 0;

  useEffect(() => {
    setTimeout(() => readNotifications(), 500);

    return () => {
      readNotifications();
    };
  }, [dispatch]);

  return (
    <div className={`d-flex flex-column h-100 ${showEmptyState ? 'your-feed-empty' : ''}`}>
      {showEmptyState ? (
        <EmptyState />
      ) : (
        webNotificationsIds.map(webNotificationsId => (
          <FeedItem
            key={webNotificationsId}
            webNotificationId={webNotificationsId}
            onCreateActionItemClick={onCreateActionItemClick}
          />
        ))
      )}
    </div>
  );
}

export default YourFeedContent;
